import Route from "vue-routisan";
import isAuthenticated from "./middlewares/isAuthenticated";
import isFinanceManager from "@/http/routes/middlewares/isFinanceManager";
import hasFinancierPermission from "@/http/routes/middlewares/hasPermission/hasFinancierPermission";

Route.group({}, () => {
  Route.group({prefix: "finance_manager", beforeEnter: [isAuthenticated, hasFinancierPermission, isFinanceManager]}, () => {
    Route.group({prefix: "finance"}, () => {

      Route.redirect("/", to => {
        return {name: "finance_manager.finance"};
      });

      Route.view("/profile", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/profile/Profile")
      ).name("finance_manager.profile");

      Route.view("/panel_notification", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/panel/PanelNotificationFinanceList")
      ).name("finance_manager.finance.panel_notification")

      Route.group({prefix: "attachments"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/attachment/AttachmentList")
        ).name("finance_manager.finance.attachments");
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               TAKERS                                                          |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "takers"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/taker/TakerList")
        ).name("finance_manager.finance.takers");
        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/taker/TakerDetails")
        ).name("finance_manager.finance.taker_details");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/taker/TakerUpdate")
        ).name("finance_manager.finance.taker_update");

        Route.view("/company_user_create/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/taker/subUser/SubUserCreate")
        ).name("finance_manager.finance.sub_user_create");
        Route.view("/company_user_create/:company_id/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/taker/subUser/SubUserUpdate")
        ).name("finance_manager.finance.sub_user_update");
      });

      /*---------------------------------------------------------------------------------------------------------------
    |                                               USERS                                                          |
    ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "users"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/user/UserList")
        ).name("finance_manager.finance.users");
        Route.view("/create", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/user/UserCreate")
        ).name("finance_manager.finance.user_create");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/user/UserUpdate")
        ).name("finance_manager.finance.user_update");
      });


      Route.group({prefix: "quotations"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/QuotationList")
        ).name("finance_manager.finance")

        Route.view("/overview", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/QuotationOverview")
        ).name("finance_manager.finance.quotation_overview")


        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/QuotationDetails")
        ).name("finance_manager.finance.quotation_details")


        Route.view("/anticipation_fatura/:fatura_id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/Anticipation/AnticipationFatura")
        ).name("finance_manager.finance.anticipation_fatura")

        Route.view("/anticipation_fatura/verification/:cte_id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/Anticipation/AnticipationFaturaVisualVerification")
        ).name("finance_manager.finance.anticipation_fatura_visual")

        Route.view("/solicitation/details/:quotation_id/:bank_id", () =>
          import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/Quotation/SolicitationDetails")
        ).name("finance_manager.finance.solicitation_details")

      });


      Route.view("/fintech", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/fintechs/FintechList")
      ).name("finance_manager.fintech");

      Route.view("/fintech/create", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/fintechs/FintechCreate")
      ).name("finance_manager.fintech_create");

      Route.view("/fintech/update/:id", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/fintechs/FintechUpdate")
      ).name("finance_manager.fintech_update");

      Route.view("/fintech/settings/:id", () =>
        import(/* webpackChunkName: "finance_manager" */ "src/resources/views/finance/financeManager/fintechs/FintechSettings")
      ).name("finance_manager.fintech_settings");


    });
  });
});

export default Route.all();
